<template>
  <label
    :for="id"
    class="switch-form"
    :style="styles"
  >
    <input
      :id="id"
      type="checkbox"
      :name="id"
      v-model="localValue"
      @change="$emit('change')"
      @click="$emit('click')"
      :checked="localValue"
    >

    <span class="switch">
      <span class="track" />
      <span class="handle" />
    </span>

    <span><slot /></span>
  </label>
</template>

<script>
export default {
  name: 'VSwitch',
  emits: ['change', 'click'],
  data() {
    return {
      localValue: this.value
    }
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    value: {},
    color: {
      type: String,
      default: 'primary',
    },
    checkedColor: {
      type: String,
      default: 'secondary',
    },
  },
  computed: {
    styles() {
      return {
        '--vx-switch-color': !!this.color ? ' var(--vx-' + this.color + ') ' : '',
        '--vx-switch-checked': !!this.checkedColor ? ' var(--vx-' + this.checkedColor + ')' : '',
      }
    },
  },
  watch: {
    localValue(value) {
      this.$emit('input', value)
    },
    value(value) {
      this.localValue = value
    }
  },
};
</script>

<style lang="scss">
@import "VSwitch";
</style>
